var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wallet"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('walletCards')], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-gray"
  }, [(_vm.showWishList) ? _c('courseWishlist') : _vm._e()], 1), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    attrs: {
      "spinner": "waveDots"
    },
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    slot: "no-more"
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65041b82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wallet/wallet.vue
// module id = GLDi
// module chunks = 1